module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.58.24.6e4b6335.jpg";